import { Component, OnInit, Input, ChangeDetectionStrategy, output } from '@angular/core';
import { SchedaMacchinaDto } from 'app/domain/SchedaMacchinaDto';
import { Guid } from 'guid-typescript';
import { ScadenzaDto } from 'app/domain/ScadenzaDto';
import { ControlContainer, NgForm, FormsModule } from '@angular/forms';

import { NgbInputDatepicker } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-promemoria-editor',
    templateUrl: './promemoria-editor.component.html',
    styleUrls: ['./promemoria-editor.component.scss'],
    viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [FormsModule, NgbInputDatepicker]
})
export class PromemoriaEditorComponent implements OnInit {

  @Input()
  legend: string;

  @Input()
  scadenza: ScadenzaDto;

  @Input()
  source: any;

  @Input()
  rowNumer = 0;

  componentId = Guid.create();

  private _namePreFix = '';

  @Input()
  get namePreFix(): string {
    return this._namePreFix + this.componentId;
  }
  set namePreFix(namePreFix: string) {
    this._namePreFix = namePreFix;
  }

  @Input()
  canDelete = false;

  readonly delete = output<number>();

  constructor() { }

  ngOnInit() {
  }

  onDelete() {
    this.delete.emit(this.rowNumer);
  }

}
